import React from 'react';
import Subscriptions from '../Subscriptions';

export default function Subscription() {
  return <Subscriptions />;
}
